import React from 'react';

import { withFormikFormControl } from '../FormikFormControl';

import DisplayRendering from "../DisplayRendering";

export const LastModifiedBy = (props) => {
  return <DisplayRendering {...props} />
};
const LastModifiedByFormik = withFormikFormControl()(LastModifiedBy);

export default LastModifiedByFormik;
